import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import { StationsState, StationsPricesReportSettings } from '../../types';

export const updateStationsPriceReportSettings = createReduxAsyncThunk<
  StationsState['stationsPriceReportSettings']['data'],
  StationsPricesReportSettings
>(
  `${STATIONS_STATE}/updateStationsPriceReportSettings`,
  async (form) => {
    await stationsAPI.updateStationsPriceReportSettings(form);
    return form;
  }
);
